export default "__VITE_ASSET__CCNCWSHM__"